import React from "react";
import ExpandableContainer from "../../../../configuration/steps/ExpandableContainer";
import { TWSInputMethodFields } from "../../Interfaces";
import BaseInputValidator from "../../../../common/input-validators/BaseInputValidator";
import formModelStore from "../../../../../store/FormModelStore";

interface SelfState {
    activeDirect: boolean | undefined,
    filterCapacity?: number
}

export default class BaseTechTable<T> extends React.Component<{
    items: T,
    temperatureProgram: string,
    fields: TWSInputMethodFields,
    renderField: (field: any, additionalProps?: object, validator?: BaseInputValidator | undefined) => any,
}, SelfState> {
    enabledIndirectDirectButton = true;
    state = {
        activeDirect: true
    }

    getFilterTemperatureProgram = () => {
        return this.props.fields?.temperatureProgram?.value
    }

    getTable() {
        return <React.Fragment />
    }

    setActiveDirect = (direct: boolean | undefined, clearTws: boolean = true) => {
        if (clearTws)
            this.clearWaterSystems();

        this.setState({ activeDirect: direct })
        formModelStore.formModel.activeDirect = direct;

        if (direct !== undefined)
            this.props.fields.productCatalogInstantaneous.setValue(direct);
    }

    componentDidMount() {
        if (!formModelStore.formModel.waterSystem.selectedTapWaterSystemModel.value && this.enabledIndirectDirectButton)
            this.setActiveDirect(true);
        else if (formModelStore.formModel.inputMethod.productCatalogCalculation.instantaneous.value !== undefined)
            this.setActiveDirect(formModelStore.formModel.inputMethod.productCatalogCalculation.instantaneous.value, false);

    }

    componentWillUnmount() {
        this.setActiveDirect(undefined);
    }

    clearWaterSystems = () => {
        formModelStore.formModel.waterSystem.selectedTapWaterSystemModel = {}
        formModelStore.formModel.waterSystem.selectedTWSOptions = []
    }

    render() {
        return <ExpandableContainer arrowFirst={true} label={__('Technical data')}
            initialOpen={true}>
            <div>
                {this.enabledIndirectDirectButton && <div className={`switcher`}>
                    <div className={`tech-data-button ${formModelStore.formModel.activeDirect ? 'active' : ''}`} onClick={() => {
                        this.setActiveDirect(true);
                    }}>{__("Instantaneous version")}</div>
                    <div className={`tech-data-button ${formModelStore.formModel.activeDirect ? '' : 'active'}`} onClick={() => {
                        this.setActiveDirect(false);
                    }}>{__("Semi-Instantaneous version")}</div>
                    {this.props.renderField(this.props.fields.temperatureProgram)}
                </div>}

                <div className={`small-stripped-data-table centered`}>
                    {this.getTable()}
                </div>

            </div>
        </ExpandableContainer>;
    }
}